export class attachmentsPaths{
events:string='';
about:string='';
news:string='';
}
